/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge,ShimmerButton,ShimmerTitle,ShimmerThumbnail, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'
import ProductSkeleton from '../../Components/ProductCard/ProductSkeleton'

function ProductListSkeleton() {
    return (
        <div>
            <div className='flex'>
                <div className="xl:block hidden min-w-[20%] max-w-[20%] pt-[26px] pb-[100px] bg-[#FFFFFF] pl-6 pr-3.5 pt-18 border-r border-[#A5A5A5] fixed h-screen sidebar overflow-auto">
                    <p className="text-lg font-bold text-[#15090E]"><ShimmerTitle line={1} gap={10} variant="primary"/></p>
                    <div className="pt-3.5">
                        <p className="text-xs7 font-bold text-[#555259] relative"><ShimmerBadge width={120}/></p>
                        <div className="relative">
                            <div className="pt-3.5 flex justify-between">
                                <p className="text-xs font-semibold text-[#000000]"><ShimmerBadge/></p>
                                <p className="text-xs font-semibold text-[#000000]"><ShimmerBadge/></p>
                            </div>
                            <div className=" mt-2 mb-4">
                                <div className="flex justify-center items-center">
                                    <div x-data="range()" x-init="mintrigger(); maxtrigger()" className="relative max-w-xl w-full">
                                        <div>
                                            <ShimmerTitle line={1} gap={10} variant="primary"/>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-1 flex items-center">
                            <div className="relative w-1/2">
                                <ShimmerButton size="md"/>
                            </div>
                            <span className="text-xs6 font-semibold text-[#000000] px-5">-</span>
                            <div className="relative w-1/2">
                                <ShimmerButton size="md"/> 
                            </div>
                        </div>
                    </div>
                    <div className="pt-3">
                        <p className="text-xs7 font-bold text-[#555259]"><ShimmerBadge width={120}/></p>
                        <div className="flex pt-1.5 -mx-2.5">
                            <div className="flex flex-col w-1/2 px-2.5">
                                <label htmlFor="Diameter" className="text-xs12 font-normal text-[#555259] pb-1.5 diameter"><ShimmerBadge width={80}/></label>
                                <ShimmerButton size="sm"/>
                            </div>
                            <div className="flex flex-col w-1/2 px-2.5">
                                <label htmlFor="length" className="text-xs12 font-normal text-[#555259] pb-1.5 diameter"><ShimmerBadge width={80}/></label>
                                <ShimmerButton size="sm"/>
                            </div>
                        </div>
                    </div>
                    <div className="pt-[18px]">
                        <p className="text-xs7 font-bold text-[#555259]"><ShimmerBadge width={120}/></p>
                        <div className="h-[230px] overflow-auto mt-[26px] sidebar">
                            {[...Array(3)].map((val)=>(
                                <button key={val} className="transition duration-150 ease-in-out flex items-center drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat1" aria-expanded="false" aria-controls="collapsecat1">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <label htmlFor="cd1" className="pl-3 text-sm font-bold text-[#555259]"><ShimmerTitle line={1} gap={10} variant="primary"/></label>
                                    </div>
                                    {/* <img src="images/Arrow_down.svg" alt="icon" className="ml-1.5 drop-btn show" /> */}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="pt-3 flex justify-center items-center">
                        <ShimmerButton size="md"/>
                    </div>
                </div>
            </div>
            <div className="xl:ml-[22%] xl:w-[78%] lg:px-[18px] md:px-[46px] px-4 pt-[18px] pb-10">
                <div className="w-full">
                    <div className="flex sm:justify-end justify-between items-center">
                        <div className="rounded-md py-2 w-fit px-4 flex items-center">
                            <div className="dropdown relative cursor-pointer">
                                <button type="button"  onClick={()=>handleToggle('sort')} id="spacial1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-sort flex items-center">
                                    <ShimmerButton />
                                </button>
                            </div>
                        </div> 
                        <div className="rounded-md py-2 w-fit px-4 flex items-center">
                            <div className="dropdown relative cursor-pointer">
                                <button type="button"  onClick={()=>handleToggle('sort')} id="spacial1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-sort flex items-center">
                                    <ShimmerButton />
                                </button>
                            </div>
                        </div>    
                    </div>
                    <ProductSkeleton />
                </div>
            </div>
        </div>                                                                                                                                                                  
         

    )
}

export default ProductListSkeleton